import { usePostHog } from "posthog-js/react";
import { useEffect } from "react";
import { useAuthenticator } from "@aws-amplify/ui-react";
import { setUser } from "@sentry/react";
import { Userpilot } from "userpilot";
import { useMeta } from "../contexts/MetaContext";

const IdentifyUser = () => {
  const { user, authStatus } = useAuthenticator();
  const { setHasUserAuthenticated } = useMeta();
  const posthog = usePostHog();

  useEffect(() => {
    const asyncMethod = async () => {
      if (authStatus === "authenticated" && user) {
        setUser({
          id: user.userId,
          email: user.signInDetails?.loginId?.toLowerCase(),
          ip_address: "{{auto}}",
        });
      } else {
        setUser(null);
        setHasUserAuthenticated(false);
      }
    };

    asyncMethod();
  }, [authStatus, user, setHasUserAuthenticated]);

  useEffect(() => {
    if (posthog && user) {
      const userProperties = {
        user_type: "PATIENT",
        email: user.signInDetails?.loginId,
      };

      posthog.identify(user.userId, userProperties);
    }
  }, [posthog, user]);

  useEffect(() => {
    if (authStatus === "authenticated" && user) {
      Userpilot.identify(user.userId, {
        email: user.signInDetails?.loginId,
        userType: "PATIENT",
      });
    } else if (authStatus === "unauthenticated") {
      Userpilot.anonymous();
    }
  }, [authStatus, user]);

  return null;
};

export default IdentifyUser;
